import { CommentStatus } from '../types';

const Badge = ({ status }: { status: CommentStatus }): JSX.Element => {
  switch (status) {
    case CommentStatus.active:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Hiển thị
        </span>
      );
    case CommentStatus.inactive:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
          Tạm ẩn
        </span>
      );
    case CommentStatus.pending:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
          Chờ duyệt
        </span>
      );
  }
};

export default Badge;
